module.exports = __webpack_public_path__ + "img/waterfront.44154165.png";